import React, {useEffect, useState} from "react";
import "../styles/NotificationSettingsPage.css";
import MyPageSidebar from "./MyPageSidebar";

const NotificationSettingsPage = () => {
    const [loading, setLoading] = useState(true);
    const [emailNotifications, setEmailNotifications] = useState(true);
    const [smsNotifications, setSmsNotifications] = useState(true);
    const [showConsentModal, setShowConsentModal] = useState(false);

    useEffect(() => {
       // 초기 알림 설정 불러오기
        const fetchNotificationSettings = async () => {
            try {
                const response = await fetch("/api/notification");
                if (response.ok) {
                    const data = await response.json();
                    setEmailNotifications(data.notificationPreference.emailOptIn);
                    setSmsNotifications(data.notificationPreference.smsOptIn);
                }
            } catch (error) {
                console.error("알림 관리 데이터 조회에 실패하였습니다.:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchNotificationSettings();

    }, []);

    // ✅ 알림 설정 업데이트
    const updateNotificationSettings = async (type, value) => {
        try {
            const response = await fetch(`/api/members/notification-preference/update/${type}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    'value' : value.toString(),
                }),
            });
            if (!response.ok) {
                console.error("알림 설정 업데이트 실패:", response.statusText);
            }
        } catch (error) {
            console.error("알림 설정 업데이트 실패:", error);
        }
    }

    // ✅ 알림 거부 처리
    const handleRefuseNotification = async () => {
        setEmailNotifications(false);
        setSmsNotifications(false);

        // ✅ 이메일 & SMS 알림을 둘 다 false로 설정
        await updateNotificationSettings("email", false);
        await updateNotificationSettings("sms", false);
    };

    // ✅ 알림 동의 처리
    const handleConfirmConsent = async () => {
        setEmailNotifications(true);
        setSmsNotifications(true);
        setShowConsentModal(false); // ✅ 팝업 닫기

        await updateNotificationSettings("email", true);
        await updateNotificationSettings("sms", true);
    };

    const handleToggleNotification = async (type) => {
        const newValue = type === "email" ? !emailNotifications : !smsNotifications;

        // ✅ UI 상태 업데이트
        if (type === "email") {
            setEmailNotifications(newValue);
        } else {
            setSmsNotifications(newValue);
        }

        // ✅ API 호출
        await updateNotificationSettings(type, newValue);
    };

    if (loading) return <p>로딩 중...</p>;

    return (
        <div className="notification-container">
            <MyPageSidebar />
            <div className="notification-content">
                <h2 className="notification-title">알림관리</h2>

                {/* ✅ 소프트캣 혜택알림 & 이벤트 알림 */}
                <div className="notification-section">
                    <h3 className="notification-subtitle">소프트캣 혜택알림 및 이벤트알림</h3>

                    <div className="notification-toggle">
                        <span>이메일로 받기</span>
                        <label className="switch">
                            <input
                                type="checkbox"
                                name="email"
                                checked={emailNotifications}
                                onChange={() => handleToggleNotification("email")}
                            />
                            <span className="slider"></span>
                        </label>
                    </div>

                    <div className="notification-toggle">
                        <span>문자로 받기</span>
                        <label className="switch">
                            <input
                                type="checkbox"
                                name="sms"
                                checked={smsNotifications}
                                onChange={() => handleToggleNotification("sms")}
                            />
                            <span className="slider"></span>
                        </label>
                    </div>
                </div>

                {/* ✅ 광고성 정보 수신 동의 */}
                <div className="notification-ad-box">
                    <h3 className="notification-subtitle">광고성 정보 수신 동의</h3>
                    <p className="notification-description">
                        소프트캣은 회원님의 수집 및 이용에 동의한 개인정보를 활용하여 SMS, MMS, 이메일 등 다양한 전자적 전송매체를 통해
                        이벤트, 혜택, 신규 서비스 관련 광고성 정보를 오전 8시부터 오후 9시 사이에 전송할 수 있습니다.<br /><br/>
                        적용 대상 - 문자, 이메일, 카카오톡, 알림톡, 푸시 등 대부분의 광고성 전송<br />
                        법적 근거 - 정보통신망법 제50조(영리목적의 광고성 정보 전송 제한)
                    </p>
                    <p className="notification-subtext">※ 수신 동의는 언제든지 [마이페이지 > 알림 설정]에서 변경 및 철회가 가능합니다.</p>
                    <div className="notification-btn-group">
                        <button className="notification-btn cancel" onClick={handleRefuseNotification}>거절</button>
                        <button className="notification-btn confirm" onClick={() => setShowConsentModal(true)}>동의</button>
                    </div>
                </div>

                {/* ✅ 동의 모달 */}
                {showConsentModal && (
                    <div className="notification-modal-overlay">
                        <div className="notification-modal">
                            <p>광고성 정보 수신에 동의하시겠습니까?</p>
                            <div className="modal-btn-group">
                                <button className="notification-btn cancel" onClick={() => setShowConsentModal(false)}>취소</button>
                                <button className="notification-btn confirm" onClick={handleConfirmConsent}>확인</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>

    );
};

export default NotificationSettingsPage;
